import React, { memo } from 'react';
import PropTypes, { oneOfType } from 'prop-types';
import ConditionColumn from './ConditionColumn';

function truncateValue(value) {
  return Number.isInteger(value) ? value : Number(value).toFixed(2);
}

function ConditionsDropdown({ signals = [] }) {
  return (
    <div className="dropdown pl-3">
      <button
        className="btn btn-link p-0 dropdown-toggle text-decoration-none text-text-light-gray d-flex align-items-center"
        type="button"
        id="conditionsDropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="true"
      >
        <span>{signals.length}</span>
        <style jsx>{`
          .dropdown-toggle:hover {
            color: var(--brand-primary) !important;
          }
        `}</style>
      </button>
      <div
        className="dropdown-menu dropdown-menu-right rounded-lg px-3 py-3 container-fluid"
        aria-labelledby="conditionsDropdown"
        style={{ width: '30rem' }}
      >
        {Array.isArray(signals) && signals.length ? (
          <div className="three-quarter-text text-muted">
            <span className="row">
              <p className="col-5">Signal</p>
              <p className="col-4 px-2">Condition</p>
              <p className="col-3">Value</p>
            </span>
            <hr className="my-2" />
            {signals.map(({ name, signalID, type, threshold, value }) => (
              <span className="row mb-1" key={signalID}>
                <p className="col-5 text-break">{name}</p>
                <p className="col-4 px-2">
                  <ConditionColumn threshold={threshold} type={type} />
                </p>
                <p className="col-3 text-alert-orange">
                  {truncateValue(value)}
                </p>
              </span>
            ))}
            <style jsx>{`
              p {
                margin-bottom: 0;
              }
            `}</style>
          </div>
        ) : (
          <span className="text-danger">
            Alert condition data not available
          </span>
        )}
      </div>
    </div>
  );
}
ConditionsDropdown.propTypes = {
  signals: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      signalID: PropTypes.string,
      threshold: oneOfType([PropTypes.number, PropTypes.string]),
      type: PropTypes.string,
      value: PropTypes.number,
    })
  ),
};
ConditionsDropdown.defaultProps = { signals: [] };

export default memo(ConditionsDropdown);
